// Central editable content for Evaya Ventures.
// Update company details, leadership profiles and enquiry options here.

export const SITE = {
  name: "Evaya Ventures",
  legalName: "Evaya Ventures Pvt. Ltd.",
  url: "https://evayaventures.com",
  tagline: "from Earth to Extraordinary",
  description:
    "Evaya Ventures is an emerging real-estate development company focused on redevelopment and thoughtfully planned plotted land development opportunities.",
  email: "connect@evayaventures.com",
  emailHref: "mailto:connect@evayaventures.com",
  phone: "+91 96194 11338",
  phoneHref: "tel:+919619411338",
  whatsapp: "https://wa.me/919619411338",
  logo: "/logo.png",
};

export const NAV_LINKS = [
  { label: "Home", path: "/" },
  { label: "About", path: "/about" },
  { label: "Redevelopment", path: "/redevelopment" },
  { label: "Plotted Development", path: "/plotted-development" },
  { label: "Our Approach", path: "/approach" },
  { label: "Developments", path: "/developments" },
  { label: "Contact", path: "/contact" },
];

export const IMAGES = {
  hero: "https://images.unsplash.com/photo-1691425700573-5e2e6e4f6157?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400",
  heroAlt: "Modern architectural facade representing thoughtful real estate development",
  redevelopmentCard: "https://images.unsplash.com/photo-1610526662524-bd113e746fdb?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  redevelopmentCardAlt: "Existing urban residential buildings with redevelopment potential",
  urbanMumbai: "https://images.unsplash.com/photo-1595658658481-d53d3f999875?q=85&w=1400&auto=format&fit=crop",
  urbanMumbaiAlt: "Mumbai skyline with high-rise residential buildings in an established urban area",
  blueprints: "https://images.unsplash.com/photo-1503387762-592deb58ef4e?q=85&w=1200&auto=format&fit=crop",
  blueprintsAlt: "Architectural drawings and development planning",
  planningHands: "https://images.unsplash.com/photo-1598368195835-91e67f80c9d7?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  planningHandsAlt: "Architects reviewing plans for a development",
  construction: "https://images.unsplash.com/photo-1541888946425-d81bb19240f5?q=85&w=1200&auto=format&fit=crop",
  constructionAlt: "Construction planning at a development site",
  plottedCard: "https://images.unsplash.com/photo-1488354028423-039ac1e23357?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  plottedCardAlt: "Aerial view of land parcels and internal roads in a plotted layout",
  landField: "https://images.unsplash.com/photo-1500382017468-9049fed747ef?q=85&w=1400&auto=format&fit=crop",
  landFieldAlt: "Open green land with an access road, suited to plotted development",
  landAerial: "https://images.unsplash.com/photo-1470075801209-17f9ec0cada6?q=85&w=1200&auto=format&fit=crop",
  landAerialAlt: "Aerial view of green surroundings around developable land",
  strategy: "https://images.unsplash.com/photo-1454165804606-c3d57bc86b40?q=85&w=1200&auto=format&fit=crop",
  strategyAlt: "Strategy and evaluation documents for development opportunities",
  meeting: "https://images.unsplash.com/photo-1542744173-8e7e53415bb0?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  meetingAlt: "Leadership team in a business discussion",
  facade: "https://images.unsplash.com/photo-1486406146926-c627a92ad1ab?q=85&w=1200&auto=format&fit=crop",
  facadeAlt: "Contemporary building facade",
  concrete: "https://images.unsplash.com/photo-1487958449943-2429e8be8625?q=85&w=1200&auto=format&fit=crop",
  concreteAlt: "Minimal architectural structure representing future developments",
};

export const DIRECTORS = [
  {
    name: "Prerna Nagdevani",
    role: "Director",
    photo: "/directors/prerna-nagdevani.jpg",
    bio: "Prerna Nagdevani is part of the leadership team at Evaya Ventures, contributing to the company's strategic direction and its vision for responsible real-estate development.",
  },
  {
    name: "Sayma Shetty",
    role: "Director",
    photo: "/directors/sayma-shetty.jpg",
    bio: "Sayma Shetty is part of the leadership team at Evaya Ventures, contributing to the company's growth, development vision and long-term business direction.",
  },
];

export const REQUIREMENT_OPTIONS = [
  "Redevelopment Opportunity",
  "Plotted Land Development",
  "Landowner Enquiry",
  "Investment Enquiry",
  "General Enquiry",
];
